import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { EducationTooltip } from '@fiverr-private/orca';
import { PACKAGE_POSITIONS } from '../../../../types/packagePositions';
import RecurringOptionSelect from '../../../shared/RecurringOptionSelect';
import RecurringOptionDiscount from '../../../shared/RecurringOptionDiscount';
import { TOOLTIP_STORAGE_KEY } from './constants';

import './style.scss';

const RECURRING_EDUCATION = 'gig_page_perseus.recurring.eduction';

const RecurringOptionsHeader = () => (
    <th className="recurring-options-header">
        <EducationTooltip className="recurring-education-tooltip"
            boxClassName="tooltip-box"
            contentClassName="tooltip-content"
            title={<I18n k={`${RECURRING_EDUCATION}.title`}/>}
            body={<I18n k={`${RECURRING_EDUCATION}.body`}/>}
            closeTitle={<I18n k={`${RECURRING_EDUCATION}.cta`}/>}
            badgeTitle={<I18n k="gig_page_perseus.general.new"/>}
            tooltipStorageKey={TOOLTIP_STORAGE_KEY}>
            <I18n k={'gig_page_perseus.recurring.subscribe_for'}/>
        </EducationTooltip>
        <RecurringOptionSelect className="option-select"
            source={PACKAGE_POSITIONS.TABLE}
            noneOptionAllowed/>
        <RecurringOptionDiscount showShortDiscount showOnSingleOrder={false}/>
    </th>
);

export default RecurringOptionsHeader;
